module.exports = {"150928105":"白音察干镇","150928106":"土牧尔台镇","150928107":"红格尔图镇","150928108":"贲红镇","150928109":"大六号镇","150928209":"当郎忽洞苏木","150928210":"乌兰哈达苏木","150928211":"锡勒乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150928.json
// module id = 562
// module chunks = 0